/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetStorefrontCheckoutConfig200ResponsePaymentMethodsValue
 */
export interface GetStorefrontCheckoutConfig200ResponsePaymentMethodsValue {
    /**
     * 
     * @type {boolean}
     * @memberof GetStorefrontCheckoutConfig200ResponsePaymentMethodsValue
     */
    delivery: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetStorefrontCheckoutConfig200ResponsePaymentMethodsValue
     */
    takeAway: boolean;
}

/**
 * Check if a given object implements the GetStorefrontCheckoutConfig200ResponsePaymentMethodsValue interface.
 */
export function instanceOfGetStorefrontCheckoutConfig200ResponsePaymentMethodsValue(value: object): value is GetStorefrontCheckoutConfig200ResponsePaymentMethodsValue {
    if (!('delivery' in value) || value['delivery'] === undefined) return false;
    if (!('takeAway' in value) || value['takeAway'] === undefined) return false;
    return true;
}

export function GetStorefrontCheckoutConfig200ResponsePaymentMethodsValueFromJSON(json: any): GetStorefrontCheckoutConfig200ResponsePaymentMethodsValue {
    return GetStorefrontCheckoutConfig200ResponsePaymentMethodsValueFromJSONTyped(json, false);
}

export function GetStorefrontCheckoutConfig200ResponsePaymentMethodsValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetStorefrontCheckoutConfig200ResponsePaymentMethodsValue {
    if (json == null) {
        return json;
    }
    return {
        
        'delivery': json['delivery'],
        'takeAway': json['takeAway'],
    };
}

export function GetStorefrontCheckoutConfig200ResponsePaymentMethodsValueToJSON(json: any): GetStorefrontCheckoutConfig200ResponsePaymentMethodsValue {
    return GetStorefrontCheckoutConfig200ResponsePaymentMethodsValueToJSONTyped(json, false);
}

export function GetStorefrontCheckoutConfig200ResponsePaymentMethodsValueToJSONTyped(value?: GetStorefrontCheckoutConfig200ResponsePaymentMethodsValue | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'delivery': value['delivery'],
        'takeAway': value['takeAway'],
    };
}

